import React from 'react'
import { Link } from 'react-router-dom'

import Moment from 'moment'

import './AppointmentNotesSection.scss'

export default {
  name: 'Appointment Notes',
  group: 'Notes & Time',
  // Removed from sidebar nav per #340. Accessible via the "Completed Appointments"
  // button in DetailsPage — navigates to ?section=N using originalIndex.
  hideFromNav: true,
  Component,
}

function Component({ getValue, appointments = [] }) {
  const getFormattedDateTime = (startUtc, endUtc) => {
    if (!startUtc) return ''
    const date = Moment.utc(startUtc).local().format('dddd, MMMM D, YYYY')
    const startTime = Moment.utc(startUtc).local().format('h:mma')
    const endTime = endUtc ? Moment.utc(endUtc).local().format('h:mma') : ''
    return endTime ? `${date} • ${startTime}-${endTime}` : `${date} • ${startTime}`
  }

  function getCompletedAndPastAppointments(appointments) {
    const dateFormat = 'MM/DD/YYYY, hh:mm:ss a'
    const list = appointments.filter(appointment => {
      return (
        appointment.complete === true ||
        Moment(Moment.utc(appointment.startUtc).local().format(dateFormat)).isSameOrBefore(
          Moment().local().format(dateFormat),
        )
      )
    })
    return getSortedAppointmentsDescendingByDate(list)
  }

  function getSortedAppointmentsDescendingByDate(appointments) {
    const format = 'MM/DD/YYYY, hh:mm:ss a'
    return appointments.sort((left, right) => {
      return Moment.utc(left.endUtc).format(format) > Moment.utc(right.endUtc).format(format)
        ? 1
        : Moment.utc(left.endUtc).format(format) < Moment.utc(right.endUtc).format(format)
        ? -1
        : 0
    })
  }

  const notesList = getCompletedAndPastAppointments(appointments)

  return (
    <div className="case-details-appointment-notes-container">
      <h4 className="pb-4">Completed Appointments</h4>
      <div className="card border-light">
        <table className="table mb-0">
          <thead>
            <tr>
              <th scope="col">APPOINTMENT</th>
              <th scope="col">APPOINTMENT DATE-TIME</th>
            </tr>
          </thead>
          <tbody>
            {notesList.map(appointment => {
              const caseNumber = getValue('caseNumber')

              return (
                <tr key={appointment.appointmentNumber}>
                  <th scope="row">
                    <div className="column-wrapper">
                      <Link
                        className="font-weight-bold"
                        to={`/cases/${caseNumber}/appointments/${appointment.appointmentNumber}`}
                      >
                        {getValue('title', '', appointment)}
                      </Link>
                    </div>
                  </th>
                  <td>
                    {getFormattedDateTime(getValue('startUtc', '', appointment), getValue('endUtc', '', appointment))}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {(!notesList || notesList.length === 0) && (
          <div className="empty-table-message-container">
            <h6 className="mb-0">No completed appointments</h6>
          </div>
        )}
      </div>
    </div>
  )
}
